import React from 'react';

export const SortDescending: React.FC<React.SVGProps<SVGSVGElement>> = ({ width, height, color }) => (
    <svg viewBox='0 0 256 256' width={width || '1em'} height={height || '1em'}>
        <polyline strokeWidth='16' strokeLinejoin='round' strokeLinecap='round' stroke={color || 'currentColor'} points='160,176 128,208 96,176 ' fill='none' />
        <line y2='208' y1='48' x2='128' x1='128' strokeWidth='16' strokeLinejoin='round' strokeLinecap='round' stroke={color || 'currentColor'} fill='none' />
    </svg>
);
